/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Fileviewer_Footer_Help_LargeInputs */



/**
* | output |
* | --- |
* | "Use arrow keys to navigate • +/- to zoom • Click and drag to pan when zoomed" |
*
* @param {Spaces_Fileviewer_Footer_Help_LargeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_fileviewer_footer_help_large = /** @type {((inputs?: Spaces_Fileviewer_Footer_Help_LargeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Fileviewer_Footer_Help_LargeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Pfeiltasten zum Navigieren • +/- zum Zoomen • Klicken und ziehen zum Verschieben beim Zoomen")
	return /** @type {LocalizedString} */ ("Use arrow keys to navigate • +/- to zoom • Click and drag to pan when zoomed")
});